export default __webpack_public_path__ + "static/media/noimg_women.9bc8efeb.png";